import C from "../../../constants";

const clearTemplatePreview = () => {
    return {
        type: C.CLEAR_TEMPLATE_PREVIEW
    }
};

export default clearTemplatePreview;